import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingSpinnerModule } from '../../components/loading-spinner/loading-spinner..module';

import { ResetPasswordComponent } from './reset-password.component';

@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerModule
  ],
  exports: [
    ResetPasswordComponent
  ],
  providers: []
})
export class ResetPasswordModule { }


